// Utility to unify asset arrays and ensure primary residence is included as an asset object
export function getAllAssetsWithPrimaryResidence(
  assets = [],
  properties = [],
  primaryResidenceValue = 0,
) {
  // Check if primary residence is already present
  const hasPrimaryResidence = assets.some(
    (asset) =>
      asset.isPrimaryResidence ||
      (asset.assetTypeName &&
        asset.assetTypeName.toLowerCase().includes("residence")),
  );
  if (hasPrimaryResidence || !primaryResidenceValue) return assets;

  // Build synthetic asset object for primary residence
  const property = properties[0] || {};
  return [
    {
      id: "primary-residence",
      isPrimaryResidence: true,
      assetTypeName: "Primary Residence",
      balance: primaryResidenceValue,
      ...property,
    },
    ...assets,
  ];
}
